export enum ErrorLevel {
  None,
  Critical,
  Handled,
  SpinLimitExceeded,
}
